<template>
  <v-container fluid>
    <v-expansion-panel style="margin-bottom: 50px;">
      <v-expansion-panel-content class="mycustomExpansionPanel">
        <template v-slot:actions>
          <v-icon large color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
          <div>
            <v-icon color="primary">search</v-icon>
            <span class="pl-2 subheading">Custom Search Panel</span>
          </div>
        </template>
        <v-layout row wrap align-center>
          <v-flex>
            <v-card class="px-3">
              <v-layout row wrap align-center class="py-3">
                <v-flex
                  xs12
                  sm12
                  md6
                  
                >
                  <v-text-field
                    class="ma-4"
                    v-model="searchParam.reg_no"
                    label="Search By Reg No"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md6
                  style="margin-top:1px; margin-bottom:8px;"
                >
                  <v-select
                    v-model="searchParam.confirm_status"
                    :items="items"
                    item-text="status"
                    item-value="value"
                    label="Select By Status"
                    persistent-hint
                    return-object
                    single-line
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="margin-top:5px;margin-bottom:8px;"
                >
                  <v-layout justify-center row fill-height align-center>
                    <v-btn
                      color="primary"
                      large
                      dark
                      @click="validationForm('search')"
                    >
                      <v-icon center dark>search</v-icon>Search
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-badge left overlap>
            <template v-slot:badge>
              <v-btn
                round
                color="primary"
                fab
                small
                style="margin-top: -1.3em;"
                class="elevation-0"
                v-if="pagination.totalItems > 0"
                >{{ pagination.totalItems }}</v-btn
              >
            </template>
            <v-card-text class="title">Incourse Candidate List</v-card-text>
          </v-badge>
        </v-card>
        <v-divider class="my-2" vertical></v-divider>

        <v-spacer />

        <v-btn color="primary" dark @click="validationForm('export_pdf')">
          Export As PDF
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
        <v-btn color="primary" dark @click="validationForm('export_xl')">
          Export As Excel
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
      </v-layout>
    </v-card>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="incourseCandidateData.data"
      class="elevation-1"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      item-key="reg_no"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ props.item.rn }}
          </td>
          <td>
            {{ props.item.reg_no }}
          </td>
          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.father_name }}
          </td>
          <td style="text-align: center;">
            {{ props.item.mobile || "-" }}
          </td>
          <td class="text-center" style="text-align: center;">
            <v-chip
              small
              :color="props.item.confirm_status == 1 ? 'green' : 'red'"
              text-color="white"
            >
              {{ props.item.confirm_status == 1 ? "Confirmed" : "Pending" }}
            </v-chip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      current_privilege: "",
      college_user: "",
      loading: false,
      sl_count: 0,
      searchParam: {
        reg_no: "",
        confirm_status: "",
        display_type: "",
      },
      pagination: {
        rowsPerPage: 50,
        rowsPerPageItems: [50, 100, 150, 200, 250],
        page: 1,
        totalItems: 0,
      },
      headers: [
        { text: "SL", value: "rn", align: "left", sortable: false },
        { text: "Reg No", value: "reg_no", align: "left", sortable: false },
        { text: "Name", value: "name", align: "left", sortable: false },
        {
          text: "Father Name",
          value: "father_name",
          align: "left",
          sortable: false,
        },
        { text: "Mobile", value: "mobile", align: "left", sortable: false },
        {
          text: "Status",
          value: "confirm_status",
          align: "left",
          sortable: false,
        },
      ],

      // pagination
      page: 1,
      per_page: 50,
      total: 0,

      items: [
        { status: "Confirmed", value: "1" },
        { status: "Pending", value: "0" },
      ],
    };
  },
  computed: {
    incourseCandidateData() {
      return this.$store.getters.getIncourseCandidatesList;
    },
  },
  watch: {
    pagination() {
      this.candidateList();
    },
  },
  created() {
    this.currentPrivilegeData();
  },
  methods: {
    currentPrivilegeData() {
      const privilege = localStorage.getItem("current-privilege");
      const collegeUser = localStorage.getItem("college-user");

      this.current_privilege = privilege ? JSON.parse(privilege) : {};
      this.college_user = collegeUser ? JSON.parse(collegeUser) : {};
    },

    setLimit() {
      const { page, rowsPerPage, sortBy } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.exam_code = this.current_privilege.exam_master.exam_code;
      this.searchParam.exam_year = this.current_privilege.exam_master.exam_year;
      this.searchParam.college_code = this.college_user.college_code;
      this.searchParam.degree_code = this.current_privilege.degree_code;
      this.searchParam.degree_group_code = this.current_privilege.degree_group_code;
      this.searchParam.subject_code = this.current_privilege.subject_code;
      this.reg_no = this.searchParam.reg_no ? this.searchParam.reg_no : "";
      this.searchParam.confirm_status = this.searchParam.confirm_status
        ? this.searchParam.confirm_status.value
        : "";
      this.searchParam.display_type = this.searchParam.display_type
        ? this.searchParam.display_type 
        : "";
    },

    candidateList() {
      try {
        if (this.searchParam.display_type) {
          this.loading = false;
        }else {
          this.loading = true;
        };
        this.setLimit();
        console.log("searchParam", typeof this.searchParam.display_type, this.searchParam.display_type);
        this.$store
          .dispatch("fetchIncourseCandidatesList", this.searchParam)

          .then((res) => {
            this.loading = false;

            this.sl_count = res.data.from || 0;

            this.pagination.totalItems = res.data.total || 0;
          });
      } catch (ex) {
        this.loading = false;
        console.log(ex);
      }
    },
    validationForm(type) {
      if (type == "search") {
        this.searchParam.display_type = "";
        this.candidateList();
      } else if (type == "export_pdf") {
        this.searchParam.confirm_status = "";
        this.searchParam.reg_no = "";
        this.searchParam.display_type = "export_pdf";
        this.candidateList();
      } else if (type == "export_xl") {
        this.searchParam.confirm_status = "";
        this.searchParam.reg_no = "";
        this.searchParam.display_type = "export_xl";
        this.candidateList();
      }

      // this.$validator.validateAll().then((isValid) => {
      //   if (isValid && item == 1) {
      //     this.candidateList(item);
      //   }
      //   if (isValid && item == 0) {
      //     this.MarkSheet();
      //   }
      // });
    },
  },
};
</script>
<style lang=""></style>
